import { signal } from "@preact/signals-react";

export class PreviewHistoryListBlocState {
  backHomeModal = signal(false);
  isEditing = signal(false);
  isModalOpen = signal(false);
  saveLoading = signal(false);
  isDropdownModalOpen = signal(false);
  isDotsBox = signal(false);
  confirmLoading = signal(false);
}

export class PreviewHistoryListItemBloc {
  constructor(public state: PreviewHistoryListBlocState) {}

  clickisDropdownModalOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.state.isDropdownModalOpen.value = true;
  };
  clickisDropdownModalOpenCancel = () => {
    this.state.isDropdownModalOpen.value = false;
  };

  clickDelete = () => {
    this.state.backHomeModal.value = true;
  };
  clickDeleteCancel = () => {
    this.state.backHomeModal.value = false;
  };

  onCloseEditing = () => {
    this.state.isEditing.value = false;
  };
  onTextClick(e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>) {
    if (!this.state.isEditing.value) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
  }

  showMoreActionsModal = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    this.state.isModalOpen.value = true;
  };
  handleCancel = () => {
    if (this.state.confirmLoading.value) return;
    this.state.isModalOpen.value = false;
  };

  clickDots = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    this.state.isDotsBox.value = !this.state.isDotsBox.value;
  };

  onClickClose = () => {
    this.state.isDotsBox.value = false;
  };

  clickDotsEdit = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    this.showMoreActionsModal(e);
    this.onClickClose();
  };
  clickDotsDelete = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    this.clickDelete();
    this.onClickClose();
  };

  getDeleteEventProps(data: any, uuid: string, link?: string): Record<string, any> {
    return {
      URL: link,
      publish_view_name: data.title,
      name: data.v2App.appName,
      uuid: uuid,
    };
  }
}
